import React, { useState } from 'react'
import { Platform, Pressable, Text, View } from 'react-native'

import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import Table from '@ui-kit/components/Table'
import RadioCardSet from '@ui-kit/components/formComponents/RadioCardSet'

import { coveragePlans } from './styles'
import type { ComparisonAccordionProps, CoveragePlanOption, CoveragePlansProps } from './types'

const PLAN_CARD_LAYOUT = Platform.OS === 'web' ? 'compact' : 'wide'

const toRadioCardOption = (plan: CoveragePlanOption) => ({
  value: plan.value,
  icon: plan.icon,
  title: plan.title,
  subtitle: plan.price,
  description: plan.description,
})

const ComparisonAccordion = (props: ComparisonAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(Boolean(props.isExpandedByDefault))
  const styles = coveragePlans()

  const toggle = () => {
    setIsExpanded(!isExpanded)
    props.onToggle?.(!isExpanded)
  }

  return (
    <View className={styles.comparison()}>
      <Pressable
        role="button"
        aria-expanded={isExpanded}
        className={styles.trigger()}
        onPress={toggle}
      >
        <Text className={styles.triggerLabel()}>{props.label}</Text>
        <PhosphorIcon name={isExpanded ? 'CaretUp' : 'CaretDown'} size={16} />
      </Pressable>
      {isExpanded ? <Table data={props.table} /> : null}
    </View>
  )
}

const CoveragePlans = (props: CoveragePlansProps) => {
  const styles = coveragePlans()

  return (
    <View className={styles.container()}>
      <RadioCardSet
        layout={PLAN_CARD_LAYOUT}
        options={props.plans.map(toRadioCardOption)}
        value={props.value}
        onValueChange={(selected) => props.onValueChange(String(selected))}
      />
      {props.comparisonTable ? (
        <ComparisonAccordion
          label={props.compareLabel}
          table={props.comparisonTable}
          isExpandedByDefault={props.isComparisonExpandedByDefault}
          onToggle={props.onComparisonToggle}
        />
      ) : null}
    </View>
  )
}

export default CoveragePlans
